
export default {
  props: {
    stops: {
      type: Number,
      default: 0
    }
  }
}
